import axios from 'axios';
import SignInService from '../../views/auth/SignInService';
import { store } from '../../redux/store';
import { showError } from '../../redux/reducers/alerts/actions';
import { updateUser } from '../../redux/reducers/user/actions';

export default class BaseApiManager {
  constructor() {
    this.baseUrl = window['apiUrl'];
    this.token = localStorage.getItem('token');
    this.userId = localStorage.getItem('userId');
  }

  getUserLanguage() {
    if (this.locale) {
      return this.locale;
    }

    const lang = navigator.language;

    if (!lang.includes('-')) {
      return navigator.languages.filter((el) => (el.includes(`${lang}-`)))[0] ?? 'en-US';
    } else if (lang) {
      return lang;
    }

    return 'en-US';
  }

  isSuccess(status) {
    return status >= 200 && status < 300;
  }

  async init(attempt = 0) {
    try {
      if (!this.userId) {
        const res = await this.get('current/user');

        if (this.isSuccess(res.status)) {
          localStorage.setItem('userId', res.data.id);
          this.userId = res.data.id;
          this.locale = res.data.locale;
          store.dispatch(updateUser(res.data));
          return res.data;
        } else {
          store.dispatch(showError(true, `Server error when try to get templates for init API. Status:${res.status}`));
        }
      }
    } catch (error) {
      return this.errorHandler(this.init.bind(this), error, attempt);
    }
  }

  async _request(url, method, body = null, headers = null) {
    const fullUrl = `${this.baseUrl}/${url}`;
    const authHeaders = { Authorization: `Bearer ${this.token}` };
    const config = {
      headers: headers ? { ...authHeaders, ...headers } : authHeaders,
    };

    if (method === 'get' || method === 'delete') {
      return axios[method](fullUrl, config);
    }

    return axios[method](fullUrl, body, config);
  }

  async get(url, headers) {
    return this._request(url, 'get', headers);
  }

  async patch(url, body, headers) {
    return this._request(url, 'patch', body, headers);
  }

  async post(url, body, headers) {
    return this._request(url, 'post', body, headers);
  }

  async put(url, body, headers) {
    return this._request(url, 'put', body, headers);
  }

  async delete(url, headers) {
    return this._request(url, 'delete', headers);
  }

  async errorHandler(handler, error, attempt, ...args) {
    if (error.response?.status === 401) {
      const signService = await SignInService.getInstance();

      if (attempt === 0) {
        await signService.refreshToken();
        this.token = localStorage.getItem('token');

        if (this.token) {
          return handler(...args, 1);
        } else {
          store.dispatch(showError(true, 'Please login again'));
          await signService.signOut();
        }
      } else {
        store.dispatch(showError(true, 'Please login again'));
        await signService.signOut();
      }
    } else {
      console.log(error);
      store.dispatch(showError(true, 'Error occurred, check console!'));
      throw error;
    }
  }
}
